import { Button as AntdButton } from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 20px;

  img {
    width: 160px;
    height: 120px;
    align-self: center;
  }

  &.error-create-porto {
    gap: 16px;

    button {
      margin-top: 24px;
    }
  }
`;

export const ContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 4px;
`;

export const Title = styled.h1`
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  margin: 0;
`;

export const Description = styled.p`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px;
  margin: 0;
  color: #858585;
`;

export const FinishButton = styled(AntdButton)`
  width: 100%;
  max-width: 160px;
  height: 44px;
  border-radius: 4px;
  font-family: ProximaNovaRg;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 19px;
  cursor: pointer;
  align-self: center;
`;
